import type { AgentRequestQuota } from '../lib/agent.js';
import React from 'react';
import { useAgentCopy } from '../lib/agentCopy.js';

export function AgentActionBalance({quota,loading=false,unavailable=false}:{quota?:AgentRequestQuota;loading?:boolean;unavailable?:boolean}) {
    const c=useAgentCopy();
    return <div role="status" aria-live="polite" className="px-4 text-center text-xs text-muted-foreground" title={c('requestsHint')}>
        {unavailable ? c('requestsUnavailable') : loading || !quota ? c('requestsLoading') : <><span>{c('requestsRemaining')}: </span><strong className="ltr-nums text-foreground">{quota.remaining===null?c('requestsUnlimited'):quota.remaining}</strong>{quota.limit!==null && <span> {c('requestsOf')} {quota.limit}</span>}</>}
    </div>;
}
